module.exports = __webpack_public_path__ + "img/pantalla-8-2.244cd6dd.png";